module.exports = __webpack_public_path__ + "img/graff.8fbfe66f.svg";